import { useSelector } from 'react-redux'

import { UserConfig } from '@/types'
import { ReduxState } from '@/config/redux/types'

const selectUserConfig = (state: ReduxState): UserConfig => state.userConfig
const selectUserLocale = (state: ReduxState): UserConfig['locale'] =>
  selectUserConfig(state).locale
const selectUserCookiePreference = (
  state: ReduxState
): UserConfig['cookiePreference'] => selectUserConfig(state).cookiePreference
const selectUserPartnerSlug = (state: ReduxState) =>
  selectUserConfig(state).partnerSlug
const selectMembershipCode = (state: ReduxState) =>
  selectUserConfig(state).membershipCode
const selectConsumerNetworkUuid = (state: ReduxState) =>
  selectUserConfig(state).consumerNetworkUuid
const selectSignupProgress = (state: ReduxState) =>
  selectUserConfig(state).signupProgress

const useUserConfig = () => useSelector(selectUserConfig)
const useUserLocale = () => useSelector(selectUserLocale)
const useUserCookiePreference = () => useSelector(selectUserCookiePreference)
const useUserPartnerSlug = () => useSelector(selectUserPartnerSlug)
const useMembershipCode = () => useSelector(selectMembershipCode)
const useConsumerNetworkUuid = () => useSelector(selectConsumerNetworkUuid)
const useSignupProgress = () => useSelector(selectSignupProgress)

export {
  useUserConfig,
  selectUserConfig,
  useUserLocale,
  selectUserLocale,
  useUserCookiePreference,
  selectUserCookiePreference,
  useUserPartnerSlug,
  selectUserPartnerSlug,
  useMembershipCode,
  selectMembershipCode,
  useConsumerNetworkUuid,
  selectConsumerNetworkUuid,
  useSignupProgress,
  selectSignupProgress,
}
